import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OnflyNetworkComponent } from "./onfly-network.component";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "../../../app/freightconfirmation/app.sharemodule";
import { LayoutModule } from "../../../app/theme/layouts/layout.module";
import { RouterModule, Routes } from "@angular/router";

import { HttpClientModule, HttpClient } from "@angular/common/http";
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../../theme/home/translateConfig.service";
// For Translator

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    LayoutModule,
    RouterModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [TranslateConfigService],
  declarations: [OnflyNetworkComponent],
  exports: [OnflyNetworkComponent],
})
export class OnflyNetworkModule { }

export { OnflyNetworkComponent };
